export default "__VITE_ASSET__B3ovDNw3__"